import { Navigate, Outlet, useLocation } from "react-router-dom";

import React from "react";
import { useSelector } from "react-redux";

const Auth = ({ allowedRoles }) => {
  const currentUserRole = useSelector((state) => state.currentUser.role);
  const auth = useSelector((state) => state.currentUser.authToken);
  console.log(currentUserRole);

  const location = useLocation();

  return auth && allowedRoles.includes(currentUserRole) ? (
    <Outlet />
  ) : auth ? (
    <Navigate to="/home" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default Auth;
